import { gql } from '@/apollo';

export const GET_SYSTEM_INFO = gql`
  query GetSystemInfo {
    systemInfo {
      environment {
        nodeVersion
        platform
        uptime
        processId
        memoryUsage {
          used
          total
          percentage
          available
        }
        cpuUsage {
          percentage
          cores
          loadAverage
        }
      }
      services {
        name
        status
        port
        health
      }
      database {
        connected
        version
        size
        connections
      }
      application {
        name
        version
        buildTime
        environment
        environmentName
        gitCommit
      }
    }
  }
`;

export const GET_SYSTEM_STATS = gql`
  query GetSystemStats {
    systemStats {
      users {
        total
        active
        administrators
        moderators
        regular
      }
      sessions {
        totalActive
        todayCreated
        averageDuration
      }
      logs {
        total
        errors
        warnings
        last24Hours
      }
      database {
        totalRecords
        tables
        size
      }
    }
  }
`;
